"use client"

import Image from "next/image"
import { MarqueeBanner, Nav, colors, exposureFont, EarlyAccessModalProvider, useEarlyAccessModal } from "../landing-page-rework/components"

function AboutUsContent() {
  const { openModal } = useEarlyAccessModal()
  
  return (
    <div className={`min-h-screen overflow-x-hidden font-inter ${exposureFont.variable}`}>
      {/* Red Marquee Banner */}
      <MarqueeBanner
        backgroundColor={colors.red}
        textColor="white"
      />

      {/* Navigation - Cream background, red logo, black text, button-style Early Access */}
      <Nav
        logoColor="red"
        backgroundColor={colors.cream}
        textColor={colors.black}
        earlyAccessStyle="button"
        earlyAccessButtonColor={colors.black}
        earlyAccessTextColor="white"
        onEarlyAccessClick={openModal}
      />

      {/* First Section - Cream background with quote and image */}
      <section
        className="relative py-16 md:py-24 lg:py-32"
        style={{ backgroundColor: colors.cream }}
      >
        {/* Small LH logo overlay - darker than background with spacing */}
        <div
          className="absolute inset-0 opacity-[0.035] pointer-events-none"
          style={{
            backgroundImage: "url(/landing/icon-lhe-logo-margin-2.png)",
            backgroundSize: "10% auto",
            backgroundPosition: "center",
            backgroundRepeat: "repeat",
          }}
        />

        <div className="relative max-w-6xl mx-auto px-6 lg:px-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            {/* Left Content - Quote with cream background box */}
            <div
              className="p-8 md:p-12 lg:p-16"
              style={{ backgroundColor: colors.cream }}
            >
              <p
                className="text-2xl md:text-2xl lg:text-3xl leading-snug text-black text-center"
                style={{ fontFamily: "var(--font-exposure), Georgia, serif" }}
              >
                At Loop Home, we believe things in your house should reflect who you are, where you've been and where you're going next.
              </p>
            </div>

            {/* Right Image - Square edges */}
            <div className="flex justify-center lg:justify-end">
              <div className="overflow-hidden shadow-2xl max-w-md">
                <Image
                  src="/landing/two-people-sitting.png"
                  alt="Person relaxing on vintage furniture"
                  width={500}
                  height={600} 
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Second Section - Red background with image left, text card right */}
      <section
        className="relative py-16 md:py-24 lg:py-32"
        style={{ backgroundColor: colors.red }}
      >
        {/* LH Watermark Pattern - large */}
        <div
          className="absolute inset-0 opacity-[0.08] pointer-events-none"
          style={{
            backgroundImage: "url(/landing/watermark-pattern.png)",
            backgroundSize: "200% auto",
            backgroundPosition: "center",
            backgroundRepeat: "repeat",
          }}
        />

        <div className="relative max-w-6xl mx-auto px-6 lg:px-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            {/* Left Image - Square edges (appears below text on mobile) */}
            <div className="flex justify-center lg:justify-start order-2 lg:order-1">
              <div className="overflow-hidden shadow-2xl max-w-md">
                <Image
                  src="/landing/about-us-image-2.jpg"
                  alt="Person lounging on vintage armchair"
                  width={500}
                  height={700}
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>

            {/* Right Content - Cream card with square edges (appears above image on mobile) */}
            <div
              className="p-8 md:p-10 lg:p-12 order-1 lg:order-2"
              style={{ backgroundColor: colors.cream }}
            >
              <p
                className="text-xl md:text-2xl lg:text-3xl leading-relaxed text-black text-center"
                style={{ fontFamily: "var(--font-exposure), Georgia, serif" }}
              >
                Our community is redefining what adulthood looks like. If you are building your first home alone, with friends or with a partner, or you are redefining your golden years through selling pieces to make space for joy, freedom or travel, you are welcome here.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default function AboutUsPage() {
  return (
    <EarlyAccessModalProvider>
      <AboutUsContent />
    </EarlyAccessModalProvider>
  )
}
